module.exports = __webpack_public_path__ + "static/media/moving-beyond-ant.f25dd515.svg";